export default [
  {
    text: '1. 설비적요인',
    value: '설비적요인',
    children: [
      {text: '1.1 끼임,감김', value: '끼임,감김'},
      {text: '1.2 절단,베임,긁힘', value: '절단,베임,긁힘'},
      {text: '1.3 맞음,무너짐', value: '맞음,무너짐'},
      {text: '1.4 부딪힘', value: '부딪힘'},
      {text: '1.5 넘어짐', value: '넘어짐'},
      {text: '1.6 떨어짐', value: '떨어짐'},
      {text: '1.7 방호장치', value: '방호장치'},
      {text: '1.8 운반수단,공기구', value: '운반수단,공기구'},
      {
        text: '1.9 기타',
        value: '기타',
        children: [
          {text: '1.9.1 기타', value: '기타1'},
          {text: '1.9.2 기타', value: '기타2'},
          {text: '1.9.3 기타', value: '기타3'},
        ]
      },
    ],
  },
  {
    text: '2. 전기적요인',
    value: '전기적요인',
    children: [
      {text: '2.1 감전', value: '감전'},
      {text: '2.2 아크', value: '아크'},
      {text: '2.3 정전기', value: '정전기'},
      {text: '2.4 기타', value: '기타'},
    ],
  },
  {
    text: '3. 화학,물질요인',
    value: '화학,물질요인',
    children: [
      {text: '3.1 가스', value: '가스'},
      {text: '3.2 증기', value: '증기'},
      {text: '3.3 에어로졸,흄', value: '에어로졸,흄'},
      {text: '3.4 액체,미스트', value: '액체,미스트'},
      {text: '3.5 분진', value: '분진'},
      {text: '3.6 반응성물질', value: '반응성물질'},
      {text: '3.7 방사선', value: '방사선'},
      {text: '3.8 화재,폭발', value: '화재,폭발'},
      {text: '3.9 복사열,과압', value: '복사열,과압'},
      {text: '3.10 기타', value: '기타'},
    ],
  },
  {
    text: '4. 생물학적요인',
    value: '생물학적요인',
    children: [
      {text: '4.1 바이러스', value: '바이러스'},
      {text: '4.2 유전자변형', value: '유전자변형'},
      {text: '4.3 알러지', value: '알러지'},
      {text: '4.4 동물', value: '동물'},
      {text: '4.5 식물', value: '식물'},
      {text: '4.6 기타', value: '기타'},
    ],
  },
  {
    text: '5. 작업특성요인',
    value: '작업특성요인',
    children: [
      {text: '5.1 소음', value: '소음'},
      {text: '5.2 초음파,저주파음', value: '초음파,저주파음'},
      {text: '5.3 진동', value: '진동'},
      {text: '5.4 실수(휴먼에러)', value: '실수(휴먼에러)'},
      {text: '5.5 저압,고압', value: '저압,고압'},
      {text: '5.6 질식,산소결핍', value: '질식,산소결핍'},
      {text: '5.7 중량물취급', value: '중량물취급'},
      {text: '5.8 반복,간헐,연속', value: '반복,간헐,연속'},
      {text: '5.9 불안정한자세', value: '불안정한자세'},
      {text: '5.10 도구,보호장구', value: '도구,보호장구'},
      {text: '5.11 숙련도', value: '숙련도'},
      {text: '5.12 기타', value: '기타'},
    ],
  },
  {
    text: '6. 작업환경요인',
    value: '작업환경요인',
    children: [
      {text: '6.1 기후,고온,한랭', value: '기후,고온,한랭'},
      {text: '6.2 조명', value: '조명'},
      {text: '6.3 공간,이동통로', value: '공간,이동통로'},
      {text: '6.4 주변작업자', value: '주변작업자'},
      {text: '6.5 작업시간,작업량', value: '작업시간,작업량'},
      {text: '6.6 조직,안전문화,리더쉽', value: '조직,안전문화,리더쉽'},
      {text: '6.7 기타', value: '기타'},
    ],
  },
  {
    text: '7. 건강관리요인',
    value: '건강관리요인',
    children: [
      {text: '7.1 건강검진', value: '건강검진'},
      {text: '7.2 적격자배치', value: '적격자배치'},
      {text: '7.3 위생보호구', value: '위생보호구'},
      {text: '7.4 구급조치', value: '구급조치'},
      {text: '7.5 증진(식단,활동)', value: '증진(식단,활동)'},
      {text: '7.6 기타', value: '기타'},
    ],
  },
  {
    text: '8. 관리적요인',
    value: '관리적요인',
    children: [
      {text: '8.1 관리조직', value: '관리조직'},
      {text: '8.2 작업규정', value: '작업규정'},
      {text: '8.3 작업안전계획', value: '작업안전계획'},
      {text: '8.4 교육,훈련', value: '교육,훈련'},
      {text: '8.5 지도,감독', value: '지도,감독'},
      {text: '8.6 작업정보,표지', value: '작업정보,표지'},
      {text: '8.7 비상대응', value: '비상대응'},
      {text: '8.8 기타', value: '기타'},
    ],
  },

]
